module.exports = ".ken-burns-slideshow__slide-img {\n  max-width: unset; }\n"